var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement-container"},[_c('div',{staticClass:"agreement-content",domProps:{"innerHTML":_vm._s(_vm.policyText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }